import React from "react";
import {
  Box,
  Drawer,
  Typography,
  IconButton,
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import { useLocation, useNavigate } from "react-router-dom";
import { useTheme, useMediaQuery } from "@mui/material";

const ChooseOption = ({ open, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();
  const navigate = useNavigate();

  const [selectedOption, setSelectedOption] = React.useState("");

  const {
    backendData,
    selectedArchetypes,
    topQEpillarsChart,
    topQEpillars,
    pillarTestSuggestions,
    finalCSV,
    initialCombinedCSV,
    updatedConfidences,
  } = location.state || {};

  const handleBack = () => {
    onClose();
    setSelectedOption("");
  };

  const handleSubmit = () => {
    if (selectedOption === "preferences") {
      onClose();
      navigate("/dashboard/qe-strategy/advisory-layer/preferences", {
        state: {
          backendData,
          topQEpillars,
          pillarTestSuggestions,
          selectedArchetypes,
          topQEpillarsChart,
          finalCSV,
          initialCombinedCSV,
          updatedConfidences,
        },
      });
    } else if (selectedOption === "topQEPillars") {
      onClose();
      navigate("/dashboard/qe-strategy/advisory-layer/top5-pillars", {
        state: {
          backendData,
          topQEpillars,
          pillarTestSuggestions,
          selectedArchetypes,
          topQEpillarsChart,
          finalCSV,
          initialCombinedCSV,
          updatedConfidences,
        },
      });
    }
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      variant="temporary"
      slotProps={{
        paper: {
          sx: {
            width: isMobile ? "100%" : 550,
            maxWidth: "100%",
            p: 3,
            boxSizing: "border-box",
            borderTopLeftRadius: theme.shape.borderRadius,
            borderBottomLeftRadius: theme.shape.borderRadius,
          },
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 3,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <IconButton
            onClick={handleBack}
            edge="start"
            aria-label="back"
            sx={{ color: "black" }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" sx={{ fontWeight: "bold", ml: 1 }}>
            Choose an option
          </Typography>
        </Box>
        <IconButton onClick={handleBack} size="small">
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Radio Options */}
      <FormControl component="fieldset" sx={{ mb: 4, width: "100%" }}>
        <RadioGroup
          value={selectedOption}
          onChange={(e) => setSelectedOption(e.target.value)}
        >
          <Box
            sx={{
              mb: 2,
              p: 2,
              borderRadius: 2,
              bgcolor: "#F6FBFF",
              display: "flex",
              alignItems: "center",
            }}
          >
            <FormControlLabel
              value="topQEPillars"
              control={<Radio />}
              label="Proceed with Top QE Pillars"
              sx={{ flex: 1, m: 0 }}
            />
          </Box>

          <Box
            sx={{
              p: 2,
              borderRadius: 2,
              bgcolor: "#F6FBFF",
              display: "flex",
              alignItems: "center",
            }}
          >
            <FormControlLabel
              value="preferences"
              control={<Radio />}
              label="Choose your Preferences"
              sx={{ flex: 1, m: 0 }}
            />
          </Box>
        </RadioGroup>
      </FormControl>

      {/* Footer Buttons */}
      <Box
        sx={{
          position: "absolute",
          bottom: 16,
          right: 16,
          left: 16,
          display: "flex",
          justifyContent: "space-between",
          flexDirection: { xs: "column", sm: "row" },
          gap: 4,
        }}
      >
        <Button
          variant="outlined"
          onClick={handleBack}
          sx={{
            width: { xs: "100%", sm: 100 },
            borderRadius: 2,
            textTransform: "none",
            borderColor: "#0094FB",
            fontWeight: 500,
            borderWidth: 2,
          }}
        >
          Back
        </Button>

        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={!selectedOption}
          sx={{
            width: { xs: "100%", sm: 110 },
            borderRadius: 2,
            backgroundColor: "#0094FB",
            textTransform: "none",
            borderColor: "#0094FB",
            "&.Mui-disabled": {
              backgroundColor: "#B3D9FF",
              color: "white",
            },
          }}
        >
          Proceed
        </Button>
      </Box>
    </Drawer>
  );
};

export default ChooseOption;
